import i18next from 'i18next';

i18next.addResources('en', 'LoginError', {
  title: 'Oops: {{error}}',
  returnToLogin: 'Return to the Login'
});
